import * as React from 'react';

import { NotFound as NotFoundPage } from 'bundles/common/components/withNotFound';
import { NotFoundError } from 'bundles/ssr/lib/errors/directives';
import inServerContext from 'bundles/ssr/util/inServerContext';

const NotFound = () => {
  // If on server, serve a true 404 (edge will handle rendering 404 page).
  if (inServerContext) {
    throw new NotFoundError();
  } else {
    return <NotFoundPage />;
  }
};

export default NotFound;
